export const EXTERNAL_API_ENTITIES = [
  "activities",
  "allocation_rule_groups",
  "assignments",
  "bank_accounts",
  "benefits_eligibility_groups",
  "billing",
  "bills",
  "break_types",
  "broadcasts",
  "budgets",
  "budget_line_items",
  "burden_rates",
  "card_balance",
  "card_transactions",
  "certification_types",
  "certifications",
  "classes",
  "classifications",
  "company_benefits",
  "company_entities",
  "cost_types",
  "crews",
  "custom_earning_codes",
  "custom_tasks",
  "customers",
  "daily_reports",
  "departments",
  "employee_benefits",
  "employee_tax_parameters",
  "equipment",
  "equipment_timesheets",
  "expense_cards",
  "expense_reimbursement_categories",
  "expense_reimbursements",
  "files",
  "fillable_templates",
  "form_submissions",
  "form_templates",
  "forms",
  "funding_strikes",
  "holiday_schedules",
  "integration_sync_items",
  "integration_syncs",
  "job_postings",
  "jobs",
  "leave_types",
  "ledger_accounts",
  "ledger_entries",
  "ledger_entry_line_items",
  "ledger_mappings",
  "locations",
  "message_templates",
  "notes",
  "onboarding_checklists",
  "overtime_rules",
  "pay_rate_groups",
  "pay_rate_versions",
  "pay_schedules",
  "payroll_payments",
  "payrolls",
  "permission_groups",
  "policies",
  "position_templates",
  "post_tax_deductions",
  "quantity_logs",
  "rate_differentials",
  "roles",
  "standard_classifications",
  "tax_deposits",
  "tax_filings",
  "tax_parameters",
  "team_members",
  "team_members_onboarding_checklists",
  "third_party_cards",
  "time_off_policies",
  "time_off_requests",
  "timesheets",
  "trades",
  "vendors",
  "work_orders",
  "workers_comp_codes",
  "workers_comp_groups",
  "workplaces",
] as const;
export type ExternalAPIEntity = (typeof EXTERNAL_API_ENTITIES)[number];

export const EXTERNAL_API_ACTIONS = ["create", "read", "update", "upsert", "delete"] as const;
export type ExternalAPIAction = (typeof EXTERNAL_API_ACTIONS)[number];

export const EXTERNAL_API_BREADTHS = ["single", "batch"] as const;
export type ExternalAPIBreadth = (typeof EXTERNAL_API_BREADTHS)[number];

export type ExternalAPIStandardScope = `${ExternalAPIEntity}:${ExternalAPIAction}:${ExternalAPIBreadth}`;

export const EXTERNAL_API_CUSTOM_SCOPES = [
  "assignments:modify_occurrence:single",
  "earnings:calculate:batch",
  "equipment_timesheets:approve:single",
  "equipment_timesheets:unapprove:single",
  "ledger_entries:regenerate:single",
  "team_members:change_entity:single",
  "team_members:enroll_payroll:single",
  "team_members:enroll_payroll:batch",
  "team_members:dismiss:single",
  "team_members:dismiss:batch",
  "team_members:rehire:single",
  "team_members:rehire:batch",
  "team_members_time_off_policies:enroll:single",
  "team_members_time_off_policies:enroll:batch",
  "team_members_time_off_policies:unenroll:single",
  "team_members_time_off_policies:unenroll:batch",
] as const;
export type ExternalAPICustomScope = (typeof EXTERNAL_API_CUSTOM_SCOPES)[number];

export type ExternalAPIScope = ExternalAPIStandardScope | ExternalAPICustomScope;

export const EXTERNAL_API_SCOPES: readonly ExternalAPIScope[] = [
  ...EXTERNAL_API_ENTITIES.flatMap((entity) =>
    EXTERNAL_API_ACTIONS.flatMap((action) =>
      EXTERNAL_API_BREADTHS.map((breadth): ExternalAPIStandardScope => `${entity}:${action}:${breadth}`)
    )
  ),
  ...EXTERNAL_API_CUSTOM_SCOPES,
];
